// extracted by mini-css-extract-plugin
export default {"image":"AdvancementImage__image___vNd4d"};